import { EditFieldValuesUseCase } from 'shared/domain/fieldValue/editFieldValues';
import { EditableFieldValuesEntityName } from 'shared/domain/fieldValue/fields';
import { EditFieldValueModel } from 'shared/domain/fieldValue/fieldValueModel';
import {
  fieldValuesRequestRunner,
  IFieldValuesRequestRunner,
} from './fieldValuesRequestRunner';
import { syncFieldValuesAfterMutation } from './fieldValueSources';

class FieldValuesChanger implements EditFieldValuesUseCase {
  constructor(private requestRunner: IFieldValuesRequestRunner) {}

  async execute(
    fieldName: EditableFieldValuesEntityName,
    fieldValues: EditFieldValueModel[]
  ): Promise<void> {
    // Synced also after a partial failure: the requests that succeeded must show.
    try {
      await this.requestRunner.execute({
        fieldName,
        fieldValues,
      });
    } finally {
      syncFieldValuesAfterMutation(fieldName);
    }
  }
}

export const fieldValuesChanger = new FieldValuesChanger(fieldValuesRequestRunner);
